import React from 'react';
import styles from "./footer.module.css"
import { Link } from "react-router-dom";
import logo from "../../imgs/logo_big.jpg";
import { useTranslation } from "react-i18next";
import { BsFacebook, BsTiktok, BsInstagram } from "react-icons/bs";
import { FaPhone, FaClock, FaGlobe, FaEnvelope, FaBolt, FaTruck, FaMapMarkerAlt, FaCreditCard } from "react-icons/fa";
import ListAmLogo from "../ListAmLogo/ListAmLogo";

const Footer = () => {
    const { t } = useTranslation()

    return (
        <footer className={styles.footer}>

            {/* Сервисные преимущества (доставка / оплата) */}
            <div className={styles.features}>
                <div className={styles.feature}>
                    <FaBolt className={styles.feature_icon} />
                    <span>{t("footer.feature_delivery_yerevan")}</span>
                </div>
                <div className={styles.feature}>
                    <FaTruck className={styles.feature_icon} />
                    <span>{t("footer.feature_post")}</span>
                </div>
                <div className={styles.feature}>
                    <FaMapMarkerAlt className={styles.feature_icon} />
                    <span>{t("footer.feature_pickup")}</span>
                </div>
                <div className={styles.feature}>
                    <FaCreditCard className={styles.feature_icon} />
                    <span>{t("footer.feature_payment")}</span>
                </div>
            </div>

            <div className={styles.inner}>

                {/* Col 1: Logo + tagline + map */}
                <div className={styles.col_logo}>
                    <Link to="/" className={styles.logo_wrap}>
                        <img src={logo} alt="SVECHA.AM" className={styles.logo_img} />
                    </Link>
                    <p className={styles.tagline}>{t("general.specialized_online_store")}</p>

                    <div className={styles.map_box}>
                        <iframe
                            title="svecha.am"
                            className={styles.map_frame}
                            src="https://maps.google.com/maps?q=40.8120991,43.8355978&z=18&output=embed"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                        <a
                            className={styles.map_btn}
                            href="https://www.google.com/maps/dir/?api=1&destination=40.8120991,43.8355978"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <FaMapMarkerAlt /> {t("footer.get_directions")}
                        </a>
                    </div>
                </div>

                {/* Col 2: Social */}
                <div>
                    <h4 className={styles.col_heading}>{t("footer.stay_connected")}</h4>
                    <ul className={styles.list}>
                        <li><a href="https://www.facebook.com/svecha.am" target="_blank" rel="noreferrer"><BsFacebook className={styles.icon} /> Facebook</a></li>
                        <li><a href="#" onClick={(e) => e.preventDefault()} title="Скоро"><BsTiktok className={styles.icon} /> TikTok</a></li>
                        <li><a href="#"><BsInstagram className={styles.icon} /> Instagram</a></li>
                        <li><a href="https://www.list.am/u/svecha" target="_blank" rel="noreferrer"><ListAmLogo size={18} className={styles.icon} /> list.am</a></li>
                    </ul>
                </div>

                {/* Col 3: Menu */}
                <div>
                    <h4 className={styles.col_heading}>{t("footer.menu")}</h4>
                    <ul className={styles.list}>
                        <li><Link to="/">{t("menu.main")}</Link></li>
                        <li><Link to="/about-us">{t("menu.about_us")}</Link></li>
                    </ul>
                </div>

                {/* Col 4: Contacts */}
                <div>
                    <h4 className={styles.col_heading}>{t("footer.contact_us")}</h4>
                    <div className={styles.contact_item}>
                        <FaEnvelope className={styles.contact_icon} />
                        <a href="mailto:svecha.am@gmail.com">svecha.am@gmail.com</a>
                    </div>
                    <div className={styles.contact_item}>
                        <FaPhone className={styles.contact_icon} />
                        <div className={styles.phones}>
                            <a href="tel:+37494093388" style={{fontSize:14,fontWeight:400}}>+374 94 09 33 88</a>
                            <a href="tel:+37494173433" style={{fontSize:14,fontWeight:400}}>+374 94 17 34 33</a>
                            <a href="tel:+37496013433" style={{fontSize:14,fontWeight:400}}>+374 96 01 34 33</a>
                            <a href="tel:+37491093388" style={{fontSize:14,fontWeight:400}}>+374 91 09 33 88</a>
                        </div>
                    </div>
                    <div className={styles.contact_item}>
                        <FaClock className={styles.contact_icon} />
                        <span className={styles.muted}>{t("footer.working_hours_1")}</span>
                    </div>
                    <div className={styles.contact_item}>
                        <FaGlobe className={styles.contact_icon} />
                        <a href="https://svecha.am">svecha.am</a>
                    </div>
                </div>

            </div>

            {/* Bottom bar */}
            <div className={styles.bottom}>
                <div className={styles.bottom_inner}>
                    <span>© 2026 SVECHA.AM — {t("footer.rights")}</span>
                    <a href="https://svecha.am">svecha.am</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
